<template>
  <div id="home">
    <!-- 栏目轮播图 -->
    <div class="defaultBox">
      <img src="@/assets/images/bs/banner.jpg" />
    </div>
    <div class="navBarBox">
      <navBar :channelId="channelId01" :channelName="channelName01"></navBar>
      <!-- <navBar :channelId="channelId02" :channelName="channelName02"></navBar> -->
      <navBar :channelId="channelId03" :channelName="channelName03"></navBar>
    </div>
  </div>
</template>

<script>
import { share } from "@/common/utils";
import navBar from "@/components/navBar.vue";

export default {
  name: "",
  components: {
    navBar
  },
  data() {
    return {
      channelId01: "9bcc2971f18f4b5b96a38a7ff8d1e47e",
      // channelId02: "7247ef00197f480ba0eb8c6ec6987a61",
      channelId03: "25f4700719b04375be733a8b09aa40c1",

      channelName01: "动态报道",
      // channelName02: "图解报告",
      channelName03: "图片集锦"
    };
  },
  mounted() {
    const info = {
      title: "中国共产党上海市宝山区第八次代表大会", //标题
      summary: "更多精彩内容，下载宝山汇App", //简介
      link: window.location.href, //链接地址
      imageUrl: "https://assets.shmedia.tech/icon/bs.png"
    };
    share(info);
  },
  methods: {}
};
</script>

<style scope>
@import "../assets/bsHome.css";
</style>
